import { ButtonTypeEnum } from '@inter-ikea-kompis/component-button';
import {
  KompisButton,
  KompisTooltip,
} from '@inter-ikea-kompis/react-components';
import { IconButton } from './IconButton';
import { SkapaTheme } from '@inter-ikea-kompis/themes/lib';
import React from 'react';
import { translate } from '../services/L10n';
import { useDispatch, useSelector } from 'react-redux';
import {
  actionOpenSeriesGallery,
  openIpexGalleryWarning,
} from '../state/dialog/dialogActions';
// @ts-ignore
import classNames from 'classnames';
import styles from './TopBar/TopBar.module.less';
import { thunkResetApp } from '../state/init/initThunks';
import { selectIsRtl } from '../state/dexfSettings/dexfSettingsSelectors';
import { IconButtonSizeEnum } from '@inter-ikea-kompis/component-icon-button';
import { selectDirtyConfigurationState } from '../state/vpc/vpcSelectors';
import { useKioskIntegration } from '../hooks/useKioskIntegration';
import { t } from '../translations';

export interface IProps {
  useArrowButton: boolean;
}

const OpenSeriesGalleryButton: React.FC<IProps> = ({ useArrowButton }) => {
  const dirtyConfiguration = useSelector(selectDirtyConfigurationState);
  const dispatch = useDispatch();
  const openSeriesGallery = (data: any) =>
    dispatch(actionOpenSeriesGallery(data));
  const isRtl = useSelector(selectIsRtl);
  const { integration, isUpptackaOrIpexGallery } = useKioskIntegration();

  const ipexGalleryShouldBeUsed = () => isUpptackaOrIpexGallery;

  const handleClick = ({ detail: { event } }: CustomEvent) => {
    if (!ipexGalleryShouldBeUsed()) {
      dispatch(
        openSeriesGallery({
          sprGalleryOptions: { closable: true },
        })
      );
    } else if (dirtyConfiguration) {
      dispatch(openIpexGalleryWarning(event));
    } else {
      integration?.exitClicked();
    }

    dispatch(thunkResetApp());
  };

  const renderArrowButton = () => (
    <KompisTooltip text={translate(t.BACK)} theme={SkapaTheme}>
      <IconButton
        type={ButtonTypeEnum.secondary}
        iconName={isRtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'}
        theme={SkapaTheme}
        onClick={handleClick}
        size={IconButtonSizeEnum.small}
        ariaLabel={translate(t.BACK)}
      />
    </KompisTooltip>
  );

  const renderSeriesGalleryButton = () => (
    <KompisButton
      className={classNames(styles.openSeriesGalleryButton)}
      type={ButtonTypeEnum.secondary}
      label={translate(t.SERIES_GALLERY_LINK)}
      theme={SkapaTheme}
      onClick={handleClick}
    />
  );

  return useArrowButton ? renderArrowButton() : renderSeriesGalleryButton();
};

export default OpenSeriesGalleryButton;
